var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$route.meta.hideNavBar)?_c('van-nav-bar',{staticClass:"van-nav-bar",attrs:{"title":_vm.$route.meta.title ? _vm.$t(_vm.$route.meta.title) : '',"left-arrow":!_vm.$route.meta.hideBackIcon},on:{"click-left":_vm.goBack}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }